<template>
  <div class="login-tit">
    <img :src="getAssetImageUrl('common/logos/scontchat-logo.svg')" alt="" />
    <h1>
      <i18n-t keypath="fast_most_accurate" scope="global">
        <template #interpreter>
          <br />
          {{ t('ai_interpreter') }}
        </template>
      </i18n-t>
    </h1>
  </div>
</template>
<script setup lang="ts">
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const { t } = useI18n();
</script>
<style scoped lang="scss">
.login-tit {
  text-align: center;
  padding: 11vh 0 13vh;
  h1 {
    font-size: 1.75rem;
    line-height: 130%;
  }
}
</style>
